const config = window.plansConfig;

export default config;
